<ami-dialog-message [setting]="message"></ami-dialog-message>

<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Actualizar producto en almacén"
  [style]="{ width: '750px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">

        <div class="mt-3 mb-2">
          <p-fieldset legend="Producto" [toggleable]="false">
            <div class="grid">
              <div class="field col-6">
                <label class="label-required">Tipo de producto</label>
                <p-dropdown
                  (onChange)="onDropdownChanged()"
                  [style]="{ width: '100%', overflow: 'visible' }"
                  formControlName="productType"
                  class="w-full"
                  placeholder="Seleccionar"
                  [options]="PRODUCTS_TYPES_NAMES_FOR_DROPDOWN"
                  optionLabel="label"
                  optionValue="value"
                ></p-dropdown>
              </div>

              <div class="field col-11">
                <label class="label-required">Producto</label>
                <input
                  formControlName="product"
                  pInputText
                  type="text"
                  class="inputfield w-full"
                  readonly
                />
              </div>
              <div class="field col-1 mt-4">
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-info"
                  pTooltip="{{
                    fg.get('productType').invalid
                      ? 'Primero selecciona el tipo de producto'
                      : 'Seleccionar producto'
                  }}"
                  [disabled]="fg.get('productType').invalid"
                  tooltipPosition="left"
                  (click)="openDialogByProductType()"
                ></button>
              </div>
            </div>
          </p-fieldset>
        </div>

        <div class="mt-3 mb-2">
          <p-fieldset
            legend="Datos"
            [toggleable]="true"
            class="mt-3 mb-2 md:mt-0"
          >
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-6">
                <label>Código de producto del proveedor</label>
                <input pInputText formControlName="code" type="text" />
                <div
                  *ngIf="
                    fg.get('code').invalid &&
                    (fg.get('code').dirty || fg.get('code').touched)
                  "
                  class="p-invalid"
                >
                  <div *ngIf="fg.get('code').errors?.required">
                    <small class="p-error">No puede quedar vacio.</small>
                  </div>
                  <div *ngIf="fg.get('code').errors?.minlength">
                    <small class="p-error"
                    >Debe tener una longitud minima de 3.</small
                    >
                  </div>
                  <div *ngIf="fg.get('code').errors?.maxlength">
                    <small class="p-error"
                    >Debe tener una longitud maxima de 10.</small
                    >
                  </div>
                </div>
              </div>
              <div class="field col-12 md:col-6">
                <label class="label-required">Descripción</label>
                <input pInputText formControlName="description" type="text" />
                <div
                  *ngIf="
                    fg.get('description').invalid &&
                    (fg.get('description').dirty ||
                      fg.get('description').touched)
                  "
                  class="p-invalid"
                >
                  <div *ngIf="fg.get('description').errors?.required">
                    <small class="p-error">No puede quedar vacio.</small>
                  </div>
                  <div *ngIf="fg.get('description').errors?.minlength">
                    <small class="p-error"
                    >Debe tener una longitud minima de 5.</small
                    >
                  </div>
                  <div *ngIf="fg.get('description').errors?.maxlength">
                    <small class="p-error"
                    >Debe tener una longitud maxima de 50.</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </p-fieldset>
        </div>

        <div class="mt-2 mb-2">
          <p-fieldset legend="Proveedor" [toggleable]="true">
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-10">
                <label class="label-required">Proveedor</label>
                <input pInputText formControlName="provider" type="text" />
              </div>
              <div class="field col-12 md:col-2">
                <button
                  pButton
                  pRipple
                  icon="pi pi-check-square"
                  class="p-button-rounded p-button-info"
                  (click)="select.provider.openDialog = true"
                  pTooltip="Seleccionar Proveedor"
                  tooltipPosition="left"
                ></button>
              </div>
            </div>
          </p-fieldset>
        </div>

        <div class="mt-2 mb-2">
          <p-fieldset legend="Unidad de medida" [toggleable]="true">
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-10">
                <label class="label-required">Unidad de medida</label>
                <input pInputText formControlName="unitMeasure" type="text" />
              </div>
              <div class="field col-12 md:col-2">
                <button
                  pButton
                  pRipple
                  icon="pi pi-check-square"
                  class="p-button-rounded p-button-info"
                  (click)="select.unitMeasure.openDialog = true"
                  pTooltip="Seleccionar unidad de medida"
                  tooltipPosition="left"
                ></button>
              </div>
            </div>
          </p-fieldset>
        </div>

        <div class="p-fluid p-formgrid grid mt-3 mb-2">
          <div class="field col-12 md:col-8"></div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              icon="pi pi-times"
              (click)="onClose()"
              class="p-button-text"
              label="No"
              pTooltip="Cancelar Cambios"
              tooltipPosition="top"
            ></button>
          </div>

          <div class="field col-12 md:col-2">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              icon="pi pi-check"
              class="p-button-text"
              [disabled]="fg.invalid || !this.changeForm"
              label="Si"
              tooltipPosition="top"
              pTooltip="Guardar Cambios"
            ></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<pg-unit-measure-select
  *ngIf="select.unitMeasure.openDialog"
  (selectedRowsEvent)="onSelectedUnitMeasure($event)"
>
</pg-unit-measure-select>

<pg-provider-select
  *ngIf="select.provider.openDialog"
  (selectedRowsEvent)="onSelectedProvider($event)"
>
</pg-provider-select>

<pg-product-unregulated-select
  *ngIf="select.product.UNREGULATED.openDialog"
  (selectedRowsEvent)="onSelectedUnregulatedProduct($event)"
>
</pg-product-unregulated-select>

<pg-regulated-product-select
  *ngIf="select.product.REGULATED.openDialog"
  (selectedRowsEvent)="onSelectedRegulatedProduct($event)"
>
</pg-regulated-product-select>
